import { render, staticRenderFns } from "./OrderDetailLogs.vue?vue&type=template&id=018eb8e3&scoped=true&"
import script from "./OrderDetailLogs.vue?vue&type=script&lang=js&"
export * from "./OrderDetailLogs.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailLogs.vue?vue&type=style&index=0&id=018eb8e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018eb8e3",
  null
  
)

export default component.exports